import React, {useState} from "react"
import { Box, Fab } from '@mui/material'
import { Add as AddIcon } from '@mui/icons-material'

import AddBloodSampleDialog from "./addBloodSampleComponents/AddBloodSampleDialog"

export default function AddBloodSample({ biestList, setBiestList, selectedFarmer }) {
   
   const [open, setOpen] = useState(false)

    return (
        <>
            <Box display='flex' justifyContent='center' >
                <Fab
                    onClick={() => setOpen(true)}
                    sx={{ position: 'fixed', top: window.innerHeight / 2 + 48 + 72, width: '60%' }}
                    variant="extended"
                    size="large"
                    color="secondary"
                    aria-label="add"
                >
                    <AddIcon sx={{ mr: 1 }} />
                    Voeg bloedStaal toe
                </Fab>
            </Box>
            <AddBloodSampleDialog open={open} setOpen={setOpen} biestList={biestList} setBiestList={setBiestList} selectedFarmer={selectedFarmer} />
        </>
    )
}